<div class="flex flex-col h-full">
    <h1 class="text-2xl">Orders</h1>
    <app-grid-toolbar
        [gridApi]="gridApi"
        [options]="gridToolbarOptions"
    ></app-grid-toolbar>
    <div class="flex-grow">
        <ag-grid-angular
            [context]="context"
            [rowData]="rowData"
            [gridOptions]="gridOptions"
            (gridReady)="onGridReady($event)"
            class="ag-theme-quartz h-100p"
        >
        </ag-grid-angular>
    </div>
</div>
